import { ErrorHandler, Injectable } from '@angular/core';
import { FirebaseX } from "@ionic-native/firebase-x/ngx";
import { Platform } from '@ionic/angular';
import * as stacktrace from "stacktrace-js";
import * as Sentry from '@sentry/browser';

@Injectable({providedIn: 'root'})
export class AppErrorHandler implements ErrorHandler {
 
  public Tag = "AppErrorHandler"
 
  constructor (
    private firebase: FirebaseX,
    private platform: Platform,
  ) {}
 
  handleError(error: any): void {
    const handledError = error && (error.originalError || error);
    console.error(handledError);

    try {
      Sentry.captureException(handledError);
    } catch (e) {
      // no-op if Sentry not initialized
    }

    if (this.platform.is("cordova")) {
      stacktrace.get().then(
        trace => this.firebase.logError(this.Tag + " | Error => " + handledError + " | Trace =>" + trace)
      );
    }
  }
}
